import React, { useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';
import styled from 'styled-components/native';
import { useTheme } from '@theme/ThemeProvider';

interface ProgressBarProps {
  progress: number; // 0-100
  height?: number;
  animated?: boolean;
  color?: string;
}

const Container = styled.View<{ height: number }>`
  height: ${({ height }) => height}px;
  background-color: ${({ theme }) => theme.colors.neutral200};
  border-radius: ${({ height }) => height / 2}px;
  overflow: hidden;
`;

export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress,
  height = 8,
  animated = true,
  color,
}) => {
  const theme = useTheme();
  const animatedValue = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    if (animated) {
      Animated.spring(animatedValue, {
        toValue: progress,
        useNativeDriver: false,
        tension: 40,
        friction: 8,
      }).start();
    } else {
      animatedValue.setValue(progress);
    }
  }, [progress, animated, animatedValue]);

  const progressColor = color || theme.colors.success;

  return (
    <Container height={height}>
      <Animated.View
        style={{
          height: '100%',
          width: animatedValue.interpolate({
            inputRange: [0, 100],
            outputRange: ['0%', '100%'],
          }),
          backgroundColor: progressColor,
          borderRadius: height / 2,
        }}
      />
    </Container>
  );
};
